import _ from 'underscore';
import * as putil from '@bingads-webui-universal/primitive-utilities';
import { getCustomColumnPreferenceName } from '@bingads-webui-universal/custom-column-utils';
import { CustomColumnServiceWrapper } from '@bingads-webui/custom-column-service-wrapper';
import { isValidForFeature } from '@bingads-webui/custom-columns-shared-config';

let Permissions;
let FeatureName;
let customColumnPreference;

export function initialize({
  globalConfig,
  featureName = '',
  customColumnPreference: customColumnPref,
}) {
  Permissions = globalConfig.get('Permissions');
  FeatureName = featureName;
  customColumnPreference = customColumnPref;
}

const pilotFlagMapping = {
  Account: 'IsCustomColumnsInAccountsSummarySupported',
  Campaign: 'IsCustomColumnsInCampaignsSupported',
  AdGroup: 'IsCustomColumnsInAdGroupsSupported',
  Ad: 'IsCustomColumnsInAdsSupported',
  AdExtensionAssociation: 'IsCustomColumnsInAdExtensionsSupported',
  Keyword: 'IsCustomColumnsInKeywordsSupported',
  SearchTerm: 'IsCustomColumnsInSearchTermsSupported',
};

const summaryTabMapping = {
  Account: 'PerformanceGrid',
  Campaign: 'summary_tab_campaign',
  AdGroup: 'summary_tab_ad_group',
  Ad: 'summary_tab_ad',
  Keyword: 'summary_tab_keyword',
  SearchTerm: 'summary_tab_search_term',
};

const excludedFeatures = [
  'PerformanceTargetOverviewGrid', // Performance target page in new UI uses Campaign as the schema name
];

export function updateEntitySchemaForCustomColumn(originalSchema, copy = true, filterExpressions = null) { // eslint-disable-line max-len
  const schema = (copy ? putil.cloneDeep : _.identity)(originalSchema);
  const schemaName = schema.name;
  const performanceMetrics = putil.get(schema, 'properties.PerformanceMetrics');
  const performanceMetricsProperties = putil.get(performanceMetrics, 'schema.properties');

  if (customColumnPreference &&
    performanceMetricsProperties &&
    Permissions[pilotFlagMapping[schemaName]] &&
    Permissions.IsCustomColumnFilterSupported && excludedFeatures.indexOf(FeatureName) < 0) {
    const summaryTab = schemaName !== 'AdExtensionAssociation' ? summaryTabMapping[schemaName] : FeatureName;
    const customColumnService = new CustomColumnServiceWrapper({
      name: getCustomColumnPreferenceName(summaryTab),
      CustomColumns: customColumnPreference.getCustomColumnPreferenceStore(summaryTab),
    });
    const customColumnData = customColumnService.getAll();

    if (customColumnData) {
      _.each(customColumnData, (customColumn) => {
        const key = `CustomColumn${customColumn.id}`;

        performanceMetricsProperties[key] = {
          isInvalidProperty: !isValidForFeature({
            schemaName,
            expression: customColumn.expression,
            permissions: Permissions,
          }),
          title: customColumn.name,
          id: customColumn.id,
          customColumn: true,
          format: customColumn.format,
          name: 'Double',
          type: 'number',
          filterable: true,
          nullable: true,
        };

        if (_.isArray(performanceMetrics.filterable) &&
          !_.contains(performanceMetrics.filterable, key)) {
          performanceMetrics.filterable.push(key);
        }
      });
    }

    if (filterExpressions) {
      _.each(filterExpressions, (filterExpression) => {
        const key = filterExpression.SelectedColumn;
        if (key.startsWith('CustomColumn') && key in performanceMetricsProperties === false) {
          performanceMetricsProperties[key] = {
            isDeletedProperty: true,
            id: key.split('CustomColumn')[1],
            customColumn: true,
            format: undefined,
            name: 'Double',
            type: 'number',
            filterable: true,
            nullable: true,
          };

          if (_.isArray(performanceMetrics.filterable)) {
            performanceMetrics.filterable.push(key);
          }
        }
      });
    }
  }

  return schema;
}
